export enum RouteTranslationKey {
    PHONE_OVERVIEW = 'routes.phone-overview',
    SECURE_INBOX = 'routes.secure-inbox',
    SECURE_INBOX_READ_MESSAGE = 'routes.secure-inbox.read-message',
    SECURE_INBOX_NEW_MESSAGE = 'routes.secure-inbox.new-message',
    SECURE_INBOX_REPLY_TO = 'routes.secure-inbox.reply-to',
    SECURE_DOCUMENT_STORE = 'routes.secure-document-store',
    SECURE_DOCUMENT_STORE_DOCUMENT_DETAILS = 'routes.secure-document-store.document-details',
    APPOINTMENT_FINDER = 'routes.appointment-finder',
    APPOINTMENT_FINDER_CONTACT_FORM = 'routes.appointment-finder.contact-form',
    ACTIVITY_LOG_BASE = 'routes.activity-logs.route',
    ACTIVITY_LOG_OWN_ACTIVITY = 'routes.activity-logs.subroute.activity',
    SETTINGS_BASE = 'routes.settings.route',
    SETTINGS_GENERAL = 'routes.settings.subroute.general',
    SETTINGS_PROFILE = 'routes.settings.subroute.profile',
    SETTINGS_ACTIVITIES = 'routes.settings.subroute.activities',
    PRODUCTS = 'routes.products',
    PRODUCT_FORM = 'routes.product-form',
    CARD_ORDER_FORM = 'routes.order-card-form',
    E_SERVICES = 'routes.eservices',
    E_TOOLS = 'routes.etools',
    EBANKING = 'routes.ebanking',
    EBANKING_PRODUCTS = 'routes.ebanking.products',
    EBANKING_MESSAGES = 'routes.ebanking.messages',
    EBANKING_DOCUMENTS = 'routes.ebanking.documents',
    CONTACT_FORM = 'routes.contact-form',
    PROSPECT_REGISTRATION_FORM = 'routes.ebanking-registration-form',
    PROSPECT_PW_RESET = 'routes.prospect-pw-reset',
}
